import {
    HttpResponse,
    QuestionGroupModel,
    QueryModel,
    RequestParams,
    QuestionGroupModelIEnumerableApiResultSuccess,
    QuestionGroupModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class QuestionGroupsDataService implements CrudService<QuestionGroupModel, QuestionGroupModel> {
    getAll(query: CrudDataQuery<QuestionGroupModel>): Promise<CrudEnumerableResponse<QuestionGroupModel>> {
        return ApiService.api.getQuestionGroupBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<QuestionGroupModel>): Promise<CrudEnumerableResponse<QuestionGroupModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<QuestionGroupModel>> {
        return ApiService.api.getQuestionGroupById(id, params);
    }

    create(item: QuestionGroupModel, params?: RequestParams): Promise<CrudResponse<QuestionGroupModel>> {
        return ApiService.api.insertQuestionGroup(item, params);
    }

    update(item: QuestionGroupModel, params?: RequestParams): Promise<QuestionGroupModel> {
        return ApiService.api.updateQuestionGroup(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<QuestionGroupModel> {
        return ApiService.api.patchQuestionGroup(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<QuestionGroupModel>): Promise<CrudEnumerableResponse<QuestionGroupModel>> {
        return ApiService.api.deleteQuestionGroups(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationQuestionGroup(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<QuestionGroupModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: QuestionGroupModel, params?: RequestParams): Promise<CrudResponse<QuestionGroupModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getQuestionGroupGroupped(query, params);
    }

}
